import { TReopenStageData } from "../store/superadmin/types";

export type Stage2ActionResult = "approve" | "admin-complete" | "referoo" | null;

type ReopenStageEntry = Omit<Pick<TReopenStageData, "reopened_at">, "reopened_at"> & {
  reopened_at: string | null;
  stage_number: number;
  sections?: string[] | null;
};

// Normalize server date strings to UTC milliseconds.
// Handles both ISO-8601 with Z ("2026-04-02T11:41:43.000000Z")
// and space-separated UTC strings without timezone ("2026-04-02 12:14:09").
export function toUTCMs(dateStr: string | null | undefined): number {
  if (!dateStr) return -Infinity;
  const normalized = dateStr.replace(' ', 'T');
  const withZ =
    /Z$|[+-]\d{2}:\d{2}$/.test(normalized) ? normalized : normalized + 'Z';
  return new Date(withZ).getTime();
}

export function getLatestStage2Action(
  profileSteps: any[],
  reopenedStagesStatus: ReopenStageEntry[] | null | undefined,
  referooCreatedAt: string | null | undefined
): Stage2ActionResult {
  const approveStep = profileSteps?.find(
    (s) => s.step_number === 1 && s.action === "approve_candidate_bypass_compliance_check"
  ); 

  const candidateCompleteViaReferoo = profileSteps?.find(
    (s) => s.step_number === 1 && s.action === "approve_candidate_to_stage_2"
  ); 

  const latestReopen = reopenedStagesStatus
    ?.filter((r) => r.stage_number === 2 && r.sections?.includes("admin_complete"))
    .reduce<ReopenStageEntry | null>((latest, curr) => {
      if (!latest) return curr;
      if (!curr.reopened_at) return latest;
      if (!latest.reopened_at) return curr;
      return toUTCMs(curr.reopened_at) > toUTCMs(latest.reopened_at) ? curr : latest;
    }, null);

  const latestReferooReopen = reopenedStagesStatus
    ?.filter((r) => r.stage_number === 2 && r.sections?.includes("candidate_complete"))
    .reduce<ReopenStageEntry | null>((latest, curr) => {
      if (!latest) return curr;
      if (!curr.reopened_at) return latest;
      if (!latest.reopened_at) return curr;
      return toUTCMs(curr.reopened_at) > toUTCMs(latest.reopened_at) ? curr : latest;
    }, null);

  const approveTime = approveStep ? toUTCMs(approveStep.created_at) : -Infinity;
  const reopenTime  = latestReopen?.reopened_at ? toUTCMs(latestReopen.reopened_at) : -Infinity;
  const referooReopenTime  = latestReferooReopen?.reopened_at ? toUTCMs(latestReferooReopen.reopened_at) : -Infinity;
  const referooTime = referooCreatedAt ? toUTCMs(referooCreatedAt) : -Infinity;
  const cadidateCompleteTime = candidateCompleteViaReferoo ? toUTCMs(candidateCompleteViaReferoo.created_at) : -Infinity;

  if (approveTime === -Infinity && reopenTime === -Infinity && referooTime === -Infinity && cadidateCompleteTime === -Infinity && referooReopenTime === -Infinity) return null;

  const max = Math.max(approveTime, reopenTime, referooTime, cadidateCompleteTime, referooReopenTime);
  if (max === referooTime) return "referoo";
  if (max === reopenTime)  return "admin-complete"; 
  if(approveStep && latestReopen === null && !referooCreatedAt) return "admin-complete"
  if(candidateCompleteViaReferoo && latestReopen === null && !referooCreatedAt) return "approve";
  return "approve";
}
